class PrintScreen {

  constructor() {
    this.printScreenButton();
    this.printSectionButton();
  };

  printSectionButton() {
    document.querySelectorAll('.btn.print-screen-cta.print-hidden').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        if (e.target === button) {

          let sectionId = button.dataset.printsection;

          document.querySelectorAll('.section.typography.cmp-rte').forEach((elem) => {
            if (elem.id != sectionId) {
              this.hideElements(elem);
              elem.closest('section').classList.add('print-hidden');
            }
            else {
              this.showAccordions(elem);
            }

          });
          window.print();

          // Wait to give some mobile devices time to render the print dialog
          setTimeout(() => {
            this.restoreElements('.section.typography.cmp-rte');
            this.hideAccordions();
          }, 500);
        }
      });
    });
  };

  printScreenButton() {
    document.querySelectorAll('.fa.fa-print').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        if (e.target === link) {

          let docId = link.dataset.printlink;
          document.querySelectorAll('.rate-table').forEach((elem) => {
            if (elem.id != docId) {
              this.hideElements(elem)
            }

          });
          window.print();

          // Wait to give some mobile devices time to render the print dialog
          setTimeout(() => {
            this.restoreElements('.rate-table');
          }, 500);
        }
      });
    });
  };


  hideElements(element) {
    element.classList.add('print-hidden')
    element.classList.add('d-none')
  }

  restoreElements(selector) {
    document.querySelectorAll(selector).forEach((element) => {
      if (element.classList.contains('d-none')) {
        element.classList.remove('print-hidden')
        element.classList.remove('d-none')
      }

      element.closest('section').classList.remove('print-hidden');
    })

    

  }

  hideAccordions() {
    document.querySelectorAll('.collapse').forEach((elem) => {
      if (elem.classList.contains('show')) {
        elem.classList.remove('show');
      }
    });
  }

  showAccordions(selector) {
    selector.nextElementSibling.querySelectorAll('.collapse').forEach((elem) => {
      if (!elem.classList.contains('show')) {
        elem.classList.add('show');
      }
    });
  }

}


document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.rate-table')) {
    const printScreen = new PrintScreen();
  }
})
